// authMiddleware.js
import store from "../store/index";
import ROUTES from "../constansRoute.js";

export default function authMiddleware(to, from, next) {
    // Acceder a las propiedades o acciones del store de autenticación
    const isAuthenticated = store.getters['appAuth/isAuthenticated'];
    // authMiddleware(to, from, next)
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // Verificar si el usuario está autenticado
        if (isAuthenticated === null) {
            next({ name: ROUTES.SIGNIN });
        } else {
            if (isAuthenticated == "false") {
                // Redirigir al usuario a la página de inicio de sesión
                next({ name: ROUTES.SIGNIN });
            } else {
                next();
                // next();
            }
        }

    } else {
        next()
    }
}
